import { toUserSelectItem } from '../../User'

import ProviderIcon from '../../../icons/provider.svg'

export function toSupplierSelectItem(item) {
  return {
    ...toUserSelectItem({
      ...item,
      id: item.owner_id,
    }),
    avatar: {
      Icon: ProviderIcon,
      src: item.avatar_url,
    },
  }
}

export function toSupplierSelectItems(items) {
  return items.map(toSupplierSelectItem)
}
